import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { AppStatus } from 'components/layout/AppStatus'
import { PathNames } from 'constants/General'
import { VerificationResult } from 'types/verification'

const VerificationStatus = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { status: statusParam } = useParams() || {}

  const status = statusParam?.toLowerCase() as VerificationResult
  const isVerificationSuccessful = status === VerificationResult.SUCCESS

  const statusMatch = Object.values(VerificationResult)?.includes(status)

  useEffect(() => {
    if (!statusMatch) {
      navigate(PathNames.NOT_FOUND, { replace: true })
    }
  }, [statusMatch])

  return (
    <AppStatus
      animationName={isVerificationSuccessful ? 'verified' : 'permissions-denied'}
      title={
        isVerificationSuccessful
          ? t('verificationStatus.successful')
          : t('verificationStatus.unsuccessful')
      }
    />
  )
}

export default VerificationStatus
